import { call, delay, put, takeLatest } from "redux-saga/effects";

// requests
import {
  createContentApi,
  editContentDataByIdApi,
  getContentDataByIdApi,
  getContentListApi,
} from "../../requests/master/contentRequests";

// actions
import {
  getContentList,
  setContentDataById,
  setContentList,
  setContentListPageCount,
} from "../../../actions/master/contentAction";
import { ContentActionTypes, ContentActions } from "../../../actionTypes/master/contentActionTypes";
import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";


function* createContentHandler(action: ContentActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createContentApi, action.payload);
    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getContentListHandler(action: ContentActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");
    const { data } = yield call(getContentListApi, action.payload);
    if (data.status) {
      yield put(setContentList(data?.data?.rows));
      yield put(setContentListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getContentDataByIdHandler(action: ContentActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getContentDataByIdApi, action.payload);
    if (data.status) {
      yield put(setContentDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editContentDataByIdHandler(action: ContentActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editContentDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getContentList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* contentSaga() {
  yield takeLatest(ContentActions.CREATE_CONTENT, createContentHandler);
  yield takeLatest(ContentActions.GET_CONTENT_LIST, getContentListHandler);
  yield takeLatest(ContentActions.GET_CONTENT_DATA_BY_ID, getContentDataByIdHandler);
  yield takeLatest(ContentActions.EDIT_CONTENT_DATA_BY_ID, editContentDataByIdHandler);
}
